import { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import he from 'he';
import { getLocale } from '!/common/helpers';

class Stats extends PureComponent {
  render() {
    const { total, pageSize, hitCount, currentPage } = this.props;
    let { query } = this.props;

    const from = currentPage === 1 ? currentPage : pageSize * (currentPage - 1) + 1;
    const to = currentPage === 1 ? hitCount : pageSize * (currentPage - 1) + hitCount;
    if (query) query = query.replace(/&quot;/g, '\"');

    if (typeof window !== "undefined" && typeof window.dataLayer !== "undefined") {
      window.dataLayer.push({event: 'search', total: total});
    }

    return <Fragment>
      <span className="search-layout__stats" data-total={total}>
        {total === 0 && (<Fragment>{getLocale('No Results')}</Fragment>) }
        {total === 1 && (<Fragment>{getLocale('1 Product')}</Fragment>) }
        {total > 1 && (<Fragment>{from} &ndash; {to} {getLocale('from')} <strong>{total}</strong> {getLocale('Products')}</Fragment>) }
        {query && (<Fragment> {getLocale('for')} <strong>{he.decode(query)}</strong></Fragment>)}
      </span>
    </Fragment>;
  }
}

function mapStateToProps({ total, perPage, hits, page, q }) {
  return {
    total,
    pageSize: perPage,
    hitCount: hits.length,
    currentPage: page,
    query: q
  };
}

export default connect(mapStateToProps)(Stats);
